import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  PaginationItem,
  Drawer,
  Alert,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddEquipment from "./AddEquipment";
import PaginationBox from "../../../Components/Masters/Pagination";
import UserDateFilter from "../Roles and Permissions/Filters/UserFilters/UserDateFilter";
import { api, get } from "../../../utils/api";
import FilterSidebar from "../../../Components/Masters/Filter/FilterSidebar";
import ApplyButton from "../Roles and Permissions/Filters/ApplyButton";
import BrandFilter from "../Roles and Permissions/Filters/BrandFilter";
import ResetButton from "../Roles and Permissions/Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { styled } from "@mui/material/styles";
import ViewEquipment from "./ViewEquipment";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import UnitFilter from "./HeatMaster/EquipmentMaster/Filters/unitFilter";
import RatedConsumptionFilter from "./HeatMaster/EquipmentMaster/Filters/ratedConsumptionFilter";
import ModelFilter from "./HeatMaster/EquipmentMaster/Filters/modelFilter";
import DeleteDialog from "../../../Components/Masters/DeleteDialog";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../Layout/MastersSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";
import TopMenu from "../../../Components/Masters/TopMenu";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getEquipmentMasterColumnWidth,
  getEquipmentMasterHeaderRowSx,
  getFacilityName,
  getGridTableRowSx,
  gridTableActionHeaderSx,
  gridTablePaperSx,
  masterDateDataCellSx,
  shouldShowFacilityColumn, FacilityDataCell, MasterDateDataCell } from "../../../utils/facilityColumn";
import MenuIcon from "../../../Components/Masters/MenuIcon";
import ColumnHeadings from "../../../Components/Masters/ColumnHeadings";

const Equipment = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = getEquipmentMasterColumnWidth(showFacilityColumn);

  const [equipments, setEquipments] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addEquipment, setAddEquipment] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Brand: false,
    Model: false,
    Unit: false,
    RatedConsumptionFilter: false,
  });
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [minConsumption, setMinConsumption] = useState("");
  const [maxConsumption, setMaxConsumption] = useState("");
  const [viewEquipment, setViewEquipment] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries
  const [selectedEqupments, setSelectedEquipments] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    Brand: false,
    Country: false,
  });

  const filters = [
    "Date",

    // "Country"
    "Brand",
    "Model",
    "Unit",
    "Rated Consumption",
  ];

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    selectedCountries: [],
    selectedEqupments: [],
    selectedModels: [],
    selectedUnits: [],
    maxConsumption: "",
    minConsumption: "",
  });

  const facilityData = [
    { header: "Date", field: "createdAt" },
    // { header: "Facility Name", field: "facilityName" },
    { header: "Brand", field: "brand" },
    // { header: "Outsource Facility", field: "outsourceFacility" },
    // { header: "Country", field: "country" },
    // { header: "Action" },
  ];
  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          // <DateRangePickerComponent
          //   url={`${api}/master/Steam/Equipement`}
          //   {...{ startDate, endDate, setStartDate, setEndDate,errors:errors.Date }}
          // />
          <UserDateFilter
            startDate={tempFilter.startDate}
            endDate={tempFilter.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            errors={errors.Date}
          />
        );
      case "Brand":
        return (
          <BrandFilter
            url={`${api}/master/Steam/Equipement`}
            selectedEqupments={tempFilter?.selectedEqupments}
            setSelectedEquipments={(equipments) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedEqupments: equipments,
              }))
            }
          />
        );
      case "Model":
        return (
          <ModelFilter
            url={`${api}/master/Steam/Equipement`}
            selectedModels={tempFilter?.selectedModels}
            setSelectedModels={(models) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedModels: models,
              }))
            }
          />
        );
      case "Unit":
        return (
          <UnitFilter
            url={`${api}/master/Steam/Equipement`}
            selectedUnits={tempFilter?.selectedUnits}
            setSelectedUnits={(units) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedUnits: units,
              }))
            }
            // errors={errors.Unit}
          />
        );
      case "Rated Consumption":
        return (
          <RatedConsumptionFilter
            minConsumption={tempFilter.minConsumption}
            maxConsumption={tempFilter.maxConsumption}
            setMinConsumption={(value) =>
              setTempFilter((prev) => ({
                ...prev,
                minConsumption: value,
              }))
            }
            setMaxConsumption={(value) =>
              setTempFilter((prev) => ({
                ...prev,
                maxConsumption: value,
              }))
            }
            errors={errors.RatedConsumption}
          />
        );
      default:
        return null;
    }
  };

  const handleMenuClick = (event, equipment) => {
    setAnchorEl(event.currentTarget);
    setSelectedEquipment(equipment);
    setdataView(equipment);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedEquipment(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddEquipment(true);
    setViewEquipment(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewEquipment(true);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setIsLoading(true);
  };

  // fetching  data
  const fetchHeatEquipment = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(`/master/Steam/Equipement?${queryParams}`);
      setEquipments(response.data.data);
      setIsLoading(false);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchHeatEquipment();
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    country: tempFilter?.selectedCountries?.join(","),
    // equipmentType: tempFilter?.equipmentType?.join(",") || [],
    brand: tempFilter?.selectedEqupments?.join(",") || [],
    model: tempFilter?.selectedModels?.join(",") || [],
    unit: tempFilter?.selectedUnits?.join(",") || [],
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    minConsumption: tempFilter?.minConsumption || null,
    maxConsumption: tempFilter?.maxConsumption || null,
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = { Date: "", Facility: "", Country: "" };
    if (selectedFilter === "Date") {
      if (startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Rated Consumption") {
      const min = parseFloat(tempFilter.minConsumption);
      const max = parseFloat(tempFilter.maxConsumption);

      // Check if both values are provided
      if (
        tempFilter.minConsumption !== "" &&
        tempFilter.maxConsumption !== ""
      ) {
        if (isNaN(min) || isNaN(max)) {
          newErrors.RatedConsumption = "Both values must be valid numbers";
          isValid = false;
        } else if (min > max) {
          newErrors.RatedConsumption =
            "Min consumption cannot be greater than max consumption";
          isValid = false;
        }
      }
      // Check if individual values are valid when only one is provided
      else if (tempFilter.minConsumption !== "" && isNaN(min)) {
        newErrors.RatedConsumption = "Min consumption must be a valid number";
        isValid = false;
      } else if (tempFilter.maxConsumption !== "" && isNaN(max)) {
        newErrors.RatedConsumption = "Max consumption must be a valid number";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    // Validate filters before applying
    if (!validateFilters()) return;
    // setPage(1);
    // // Prepare the filters for RatedConsumption, add to other filters
    const consumptionFilter = {
      minConsumption: tempFilter.minConsumption || null,
      maxConsumption: tempFilter.maxConsumption || null,
    };

    // fetchHeatEquipment();
    setPage(1);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
    setSelectedCountries(tempFilter?.selectedCountries);
    setSelectedEquipments(tempFilter?.selectedEqupments);
    setSelectedModels(tempFilter?.selectedModels);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setMinConsumption(tempFilter.minConsumption);
    setMaxConsumption(tempFilter.maxConsumption);
    setSelectedUnits(tempFilter?.selectedUnits);
    fetchHeatEquipment({
      ...filtersToApply, // All the previously selected filters
      ...consumptionFilter, // Add the rated consumption filter
    });
  };

  // Applying reset filters
  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedCountries([]);
    setSelectedEquipments([]);
    setSelectedModels([]);
    setSelectedUnits([]);
    setMinConsumption("");
    setMaxConsumption("");
    setTempFilter({
      selectedCountries: [],
      selectedEqupments: [],
      selectedModels: [],
      startDate: null,
      endDate: null,
      minConsumption: null,
      maxConsumption: null,
      selectedUnits: [],
    });
    setAppliedFilters({});
    setIsFiltersApplied(false);
    fetchHeatEquipment({});
    setErrors({});
    setDrawerFilterOpen(false);
  };

  // handle the applied filters for styling
  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isCountryApplied = tempFilter?.selectedCountries.length > 0;
    const isBrandApplied = tempFilter?.selectedEqupments.length > 0;
    const isModelApplied = tempFilter?.selectedModels.length > 0;
    const isUnitApplied = tempFilter?.selectedUnits.length > 0;
    // const isFunctionalityOfRoleApplied = functionalityOfRoleFilter.length > 0;
    const isRatedConsumptionFilter =
      minConsumption || maxConsumption ? true : false;

    setIsFiltersApplied(
      isDateApplied ||
        isCountryApplied ||
        isBrandApplied ||
        isModelApplied ||
        isUnitApplied ||
        isRatedConsumptionFilter
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Country: isCountryApplied,
      Brand: isBrandApplied,
      Model: isModelApplied,
      Unit: isUnitApplied,
      RatedConsumptionFilter: isRatedConsumptionFilter,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  // const getManualWidth = (header) => {
  //   switch (header) {
  //     case 'Date':
  //       return '12%';
  //     case 'FacilityName':
  //       return '22%';
  //     case 'Incharge':
  //       return '20%';
  //     case 'Outsource Facility':
  //       return '15%';
  //     case 'Country':
  //       return '21%';
  //     case 'Action':
  //       return '10%';
  //     default:
  //       return 'auto'; // default width if header doesn't match
  //   }
  // };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      selectedCountries: selectedCountries,
      selectedEqupments: selectedEqupments,
      selectedModels: selectedModels,
      minConsumption: minConsumption,
      maxConsumption: maxConsumption,
    });
    setDrawerFilterOpen(false);
    setErrors({ Date: false, Role: false });
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              // onClose={handleClose}
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
              {/* Add user Successfully */}
            </Alert>
          </Snackbar>
          <AddEquipment
            addEquipment={addEquipment}
            setAddEquipment={setAddEquipment}
            fetchHeatEquipment={fetchHeatEquipment}
            setsnackOpen={setsnackOpen}
            //  addFacility={addFacility}
            selectedEquipment={dataView}
          />
          <ViewEquipment
            viewEquipment={viewEquipment}
            setViewEquipment={setViewEquipment}
            selectedEquipment={dataView}
            handleEdit={handleEdit}
          />
          {/* <AddFacility
        addFacility={addFacility}
        selectedEquipment={dataView}
        fetchHeatEquipment={fetchHeatEquipment}
        setsnackOpen={setsnackOpen}
      />
      <ViewFacility
        viewFacility={viewFacility}
        setViewFacility={setViewFacility}
        selectedEquipment={dataView}
      /> */}
          {deleteDialog && (
            // <DeleteDialog
            //   {...{ deleteDialog, setDeleteDialog, handleDeleteAggree}}
            // />
            <DeleteDialog
              {...{
                deleteDialog,
                setDeleteDialog,
                id: dataView._id,
                url: `${api}/master/Steam/DeleteEquipment`,
                setsnackOpen,
                fetchData: fetchHeatEquipment,
              }}
            />
          )}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => {
                handleFilterDrawer();
              }}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "3%",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      handleFilterDrawer();
                    }}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}{" "}
          {/* <Grid container alignItems="center" sx={{ width: "98%" }}>
            <Grid item xs={6}> */}
          {/* <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width: !user?.companyAdmin ? "96%" : "100%",
              marginRight: "1.5%",
              // justifyContent: "flex-end",
              // ml: "20%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  // pt: "2rem",
                  fontWeight: "bold",
                  // margin: "0px 0px 20px 0px",
                  textDecoration: "underline",
                  // paddingLeft: "20px",
                  // paddingTop: "10px",
                  marginLeft: "0",
                }}
              >
                Scope 2
              </Typography>
            </Box>
            <Box item xs={6} sx={{ textAlign: "right", margin: "1rem 0.2rem" }}>
              <Button
                variant="contained"
                onClick={() => {
                  setTempFilter({
                    startDate: startDate,
                    endDate: endDate,
                    selectedCountries: selectedCountries,
                    selectedUnits: selectedUnits,
                    maxConsumption: maxConsumption,
                    minConsumption: minConsumption,
                    selectedModels: selectedModels,
                    selectedEqupments: selectedEqupments,
                  });
                  setDrawerFilterOpen(true);
                }}
                // endIcon={<FilterListIcon />}
                sx={{
                  // margin: "10px 10px 5px 0px",
                  margin: !user?.companyAdmin ? "0px 10px 0px 0px" : "0px",
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {(tempFilter?.selectedCountries?.length > 0 ||
                  tempFilter?.selectedEqupments?.length > 0 ||
                  tempFilter?.selectedModels?.length > 0 ||
                  tempFilter?.selectedUnits?.length > 0 ||
                  tempFilter?.maxConsumption ||
                  tempFilter?.minConsumption ||
                  tempFilter?.startDate ||
                  tempFilter?.endDate) && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              {!user?.companyAdmin && (
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    margin: "10px -36px 9px 0px",
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddEquipment(true);
                    setdataView(null);
                  }}
                >
                  Add New
                </Button>
              )}
            </Box>
          </Box> */}
          <TopMenu
            setData={setdataView}
            setAddData={setAddEquipment}
            onClick={() => {
              setTempFilter({
                startDate: startDate,
                endDate: endDate,
                selectedCountries: selectedCountries,
                selectedUnits: selectedUnits,
                maxConsumption: maxConsumption,
                minConsumption: minConsumption,
                selectedModels: selectedModels,
                selectedEqupments: selectedEqupments,
              });
              setDrawerFilterOpen(true);
            }}
            {...{
              heading: "Scope 2",
              setDrawerFilterOpen,
              filterApplied:
                tempFilter?.selectedCountries?.length > 0 ||
                tempFilter?.selectedEqupments?.length > 0 ||
                tempFilter?.selectedModels?.length > 0 ||
                tempFilter?.selectedUnits?.length > 0 ||
                tempFilter?.maxConsumption ||
                tempFilter?.minConsumption ||
                tempFilter?.startDate ||
                tempFilter?.endDate,
            }}
          />
          <TableContainer
            component={Paper}
            sx={{ ...gridTablePaperSx, overflowX: "hidden" }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    // padding: "0px",
                  }}
                >
                  Steam Equipment Master
                </Box>
              </Box>
              <Box
                sx={{
                  ...getEquipmentMasterHeaderRowSx(columnWidth),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                <ColumnHeadings
                  title="Date"
                  key="Date"
                  handleSort={handleSort}
                  field="createdAt"
                  sortConfig={sortConfig}
                />
                {showFacilityColumn && (
                  <FacilityColumnHeading
                    handleSort={handleSort}
                    sortConfig={sortConfig}
                  />
                )}
                <ColumnHeadings
                  title="Equipment Name"
                  key="Equipment Name"
                  handleSort={handleSort}
                  field="equipment"
                  sortConfig={sortConfig}
                />
                <ColumnHeadings
                  title="Brand"
                  key="Brand"
                  handleSort={handleSort}
                  field="brand"
                  sortConfig={sortConfig}
                />
                <ColumnHeadings
                  title="Model"
                  key="Model"
                  handleSort={handleSort}
                  field="model"
                  sortConfig={sortConfig}
                />
                <ColumnHeadings
                  title="Rated Consumption / Hour"
                  key="Rated Consumption / Hour"
                  handleSort={handleSort}
                  field="ratedConsumption"
                  sortConfig={sortConfig}
                />
                <ColumnHeadings
                  title="Unit"
                  key="Unit"
                  handleSort={handleSort}
                  field="unit"
                  sortConfig={sortConfig}
                />
                <Typography sx={gridTableActionHeaderSx}>Action</Typography>
              </Box>
              {equipments.length === 0 ? (
                <NoDataFound />
              ) : (
                equipments.map((equipments) => (
                  <Box
                    key={equipments._id}
                    sx={{
                      ...getGridTableRowSx(columnWidth),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <MasterDateDataCell>
                      {new Date(equipments.createdAt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )}
                    </MasterDateDataCell>
                    {showFacilityColumn && (
                      <FacilityDataCell>
                        {getFacilityName(equipments) || "N/A"}
                      </FacilityDataCell>
                    )}
                    <FacilityDataCell>
                      {equipments.equipment}
                    </FacilityDataCell>
                    <FacilityDataCell>
                      {equipments.brand}
                    </FacilityDataCell>
                    <FacilityDataCell>
                      {equipments.model}
                    </FacilityDataCell>
                    <FacilityDataCell>
                      {equipments.ratedConsumption}
                    </FacilityDataCell>
                    <FacilityDataCell>
                      {equipments.unit}
                    </FacilityDataCell>
                    <MenuIcon
                      handleMenuClick={handleMenuClick}
                      field={equipments}
                    />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* </TableContainer> */}
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          {/* Menu for Actions */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            {user?.companyAdmin ? (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
                <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
                  <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Edit
                </MenuItem>
                <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
                  <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Delete
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Equipment;
